import React, { useMemo, useRef } from "react";

// Components
import Button from "components/UiKit/Button";
import FieldSelect from "components/UiKit/FieldSelect";
import FieldCheckbox from "components/UiKit/FieldCheckbox";

// Lib
import { useWindowSize } from "lib/hooks";
import { shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";
import { convertedToArray, convertProjectsToOptions, filteredDataPrices } from "lib/helpers";

// Classnames
import clsx from "clsx";

// Actions
import { openModal } from "reducers/modal";
import { showMessage } from "reducers/messages";
import * as actionsCreatorProject from "pages/Projects/reducer";
import * as actionCreators from "pages/LibrariesCompounds/reducer";
import { handlerChangePriceApp, toggleModal } from "reducers/settings";
import { getAllPOAInStock, TContent } from "pages/LibrariesCompounds/reducer";

// Styles
import { selectStyle } from "constans/react-select-style";

// Constants
export const optionsAccessibility = [
  { label: "All", value: "ALL" },
  { label: "In stock/POA", value: "ON_STOCK_POA" },
  { label: "In stock", value: "ON_STOCK" },
  { label: "Out of stock", value: "OUT_OF_STOCK" }
];

export const styleFieldSelectPrices = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    height: "4rem",
    width: "10rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {}
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    height: "4rem",
    border: "unset",
    width: "10rem",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  })
};
export const styleFieldSelectProject = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    height: "4rem",
    width: "27rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "1.8rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  }),
  input: (p: any) => ({
    ...p,
    color: "#191919"
  }),
  value: (p: any) => ({
    ...p,
    lineHeight: "1.8rem"
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#191919",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "1.8rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {}
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    width: "27rem",
    height: "4rem",
    border: "unset",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "1.8rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  })
};
export const styleFieldSelectAccessibility = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    height: "4rem",
    width: "9.3rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "14rem",
    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    width: "9.3rem",
    height: "4rem",
    border: "unset",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  })
};

// Type
type TFuncArgs = {
  [index: string]: string | number | undefined;
}

// Interface
interface IHeaderList {
  id?: string;
  isModal?: boolean;
  className?: string;
  state: {
    type: string,
    name: string,
    catNumber: string,
    description: string,
    currentValue: string,
    compoundsCount: number,
  },
}

/**
 *  Component
 * @returns React.ReactNode
 */
export const HeaderList: React.FC<IHeaderList> = (props) => {
  const { id = '', className = '', isModal = false } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ref: any = useRef(null);
  const keyLocalStoreIds = "libCompoundsIds";

  const {
    user,
    currentPrice,
    dataProjects,
    currentProject,

    data,
    checkboxAll,
    accessibility,
  } = useAppSelector(
    (store) => {
      return {
        user: store.settings.user,
        currentPrice: store.settings.currentPrice,

        dataProjects: store.projects.dataProjects,
        currentProject: store.projects.currentProject,

        data: store.librariesCompounds.data,
        checkboxAll: store.librariesCompounds.checkboxAll,
        accessibility: store.librariesCompounds.accessibility,
      }
    },
    shallowEqual
  );

  const { width } = useWindowSize();
  const isDesktop = width < 1024;

  const content = data.content;
  const totalElements = data.totalElements;
  const prices = content?.length ? content[0]?.prices[0]?.prices : [];
  const listLibrariesCompounds = JSON.parse(localStorage.getItem(keyLocalStoreIds) || "[]");
  const convertedProjects = convertedToArray(dataProjects);
  const optionsProjects = convertProjectsToOptions(dataProjects);

  const findElement = useMemo(() => {
    return optionsProjects?.find(
      (item: TFuncArgs) => item.value === +currentProject
    );
  }, [optionsProjects, currentProject]);

  const projectValue = user?.authorized
    ? findElement : [];

  const countSelectedItems = listLibrariesCompounds?.filter(
    (item: actionCreators.TContent) => item.selected
  )?.length;
  const disabledAddProject = !!countSelectedItems;
  const options: any = prices?.length
    ? filteredDataPrices(prices)?.map(
      (item) => {
        return {
          type: "Usd",
          label: `${item.mg}mg`,
          mg: item.mg ? item.mg : null,
          value: item.mg ? `price${item.mg}mg` : "",
          price: item?.priceUsd ? item?.priceUsd : "POA"
        };
      }
    )
    : [];

  const handlerChangeCheckboxAll = () => {
    dispatch(actionCreators.handlerChangeCheckboxSelectAll());
  };

  const handlerAddToProject = () => {
    if (!user.authorized) {
      dispatch(toggleModal(true));
      return;
    }

    const uniqId = crypto.randomUUID();
    let result: actionCreators.TContent[] = [];

    for (const item of listLibrariesCompounds || []) {
      const hasPrices = Object.values(item?.currentPrice)
        .filter(Boolean)
        .length;

      if (
        item.selected &&
        !hasPrices
      ) {
        dispatch(showMessage({
          type: "info",
          uniqId: uniqId,
          text: "Choose price/mg"
        }));
        result = [];
        break;
      }

      if (
        item.selected &&
        hasPrices
      ) result.push(item);
    }

    const newData = result.map((item: any) => {
      const supIds = item.supIds;
      const findElement = listLibrariesCompounds?.find(
        (elem: any) => elem?.id === item?.id
      );
      const currentTypePrice = findElement?.currentTypePrice;
      const findProductId = supIds?.find(
        (supId: any) => supId.supplier === currentTypePrice
      );

      return {
        ...item,
        id: findProductId?.supId || '',
        supplier: currentTypePrice,
      }
    });

    if (currentProject && newData?.length) {
      dispatch(actionsCreatorProject.addItemToProject({
        data: newData,
        uniqId: uniqId,
        url: "/projects",
        id: currentProject,
        title: "Compound Added to project",
        text: "Review or continue browsing. Contact<br/> us for any questions. Thank you!"
      }));
      return;
    }

    const itemsWithValidPrice = newData.filter(
      (item: any) => item.currentPrice && item.currentPrice.mg
    );

    if (!currentProject && itemsWithValidPrice.length) {
      const modalConfig = {
        data: newData,
        url: "/projects",
        navigate: navigate,
        isAddItem: "isAddItem",
        title: "Compound Added to project",
        type: convertedProjects.length ? "projectsList" : "projectAdd",
        text: "Review or continue browsing. Contact<br/> us for any questions. Thank you!"
      };

      dispatch(openModal(modalConfig));
    }
  };

  const handlerConfirmChangePrice = (selected: TFuncArgs) => {
    dispatch(openModal(
      {
        data: selected,
        color: "error",
        type: "confirm",
        textClose: "Cancel",
        textSubmit: "Confirm",
        actionSubmit: handlerChangePrices,
        innerClass: "libraries-compounds__confirm",
        text: `The default prepackage size of all compounds will be set to ${selected.mg} mg`
      })
    );
  };

  const handlerChangePrices = (selected: TFuncArgs) => {
    const listIds = JSON.parse(localStorage.getItem(keyLocalStoreIds) || "[]");

    dispatch(handlerChangePriceApp(selected));
    const updatePricesAll = listIds.map((item: TContent) => ({ ...item, currentPrice: selected }));
    localStorage.setItem(keyLocalStoreIds, JSON.stringify(updatePricesAll));
  };

  const handlerClearPriceAll = () => {
    const listIds = JSON.parse(localStorage.getItem(keyLocalStoreIds) || "[]");
    ref.current.setValue([]);
    dispatch(handlerChangePriceApp([]));
    const updatePricesAll = listIds.map((item: TContent) => ({ ...item, currentPrice: {} }));
    localStorage.setItem(keyLocalStoreIds, JSON.stringify(updatePricesAll));
  };

  const handlerConfirmClearPrice = () => {
    dispatch(openModal(
      {
        color: "error",
        type: "confirm",
        textClose: "Cancel",
        textSubmit: "Confirm",
        actionSubmit: handlerClearPriceAll,
        innerClass: "libraries-compounds__confirm",
        text: `The default prepackage size of all compounds will be set to manual selection.`
      })
    );
  };

  const handlerClearAllCheckboxSelected = () => {
    dispatch(actionCreators.handlerClearAllCheckboxSelected());
  };

  const handlerChangeProject = (selected: TFuncArgs) => {
    dispatch(
      actionsCreatorProject.handlerChangeCurrentProject(selected.value)
    );
  };

  const handlerChangeAccessibility = (opt: TFuncArgs) => {
    dispatch(actionCreators.handlerChangeAccessibility(opt));

    dispatch(actionCreators.getLibrariesCompounds(id));
  };

  const handlerDownloadPOA = () => {
    dispatch(getAllPOAInStock(id));
  };

  const isAvailabilityValid = (value: string) => {
    return value !== "OUT_OF_STOCK" && value !== "ON_STOCK_POA";
  };

  const filteredDataByType = (args: { type: string }) => (item: TContent) => {
    const { type } = args;

    if (type === "selected") {
      return item.selected;
    }
  };

  const handleChangeToggleFilter = () => {
    dispatch(actionCreators.changeToggleFilter())
  };

  const icon = isModal
    ? 'crossSvg'
    : "filterSvg";

  const filteredCompounds = listLibrariesCompounds.filter(filteredDataByType({ type: "selected" }));
  const labelAddSelected = `Add ${filteredCompounds.length} selected`;

  const cnWrapper = clsx("libraries-compounds__header-list", className);

  return (
    <div className={cnWrapper}>
      <div className="libraries-compounds__header-top mb50 flex flex-ai-end flex-jc-between flex-direction-column-desktop">
        <div className="libraries-compounds__header-top-left-wrapper flex flex-ai-center">
          <div className="libraries-compounds__header-top-left flex flex-ai-end">
            {isDesktop && isAvailabilityValid(accessibility?.value || "") && <FieldCheckbox
              label="Select all"
              value={checkboxAll}
              name="checkboxItemAll"
              onChange={handlerChangeCheckboxAll}
              classNameLabel="libraries-compounds__checkbox-all"
              className="libraries-compounds__checkbox-all-mobile ml10"
            />}

            <p className="libraries-compounds__filters-text">Filters</p>

            <div className="libraries-compounds__selected-block flex flex-jc-between flex-ai-end">
              <div className="libraries-compounds__selected-block-left flex flex-direction-column">
                <p className="libraries-compounds__prices-list-all">Selected</p>
                <p className="libraries-compounds__text-of flex flex-ai-center">
                  {filteredCompounds.length} of {totalElements}
                </p>
              </div>
              <Button
                isSvg
                variable="icon"
                color="error"
                icon="deleteSvg"
                title="Clear checkbox all"
                disabled={!disabledAddProject}
                onPress={handlerClearAllCheckboxSelected}
                className="libraries-compounds__selected-delete ml10"
              />
            </div>

            <Button
              isSvg
              icon={icon}
              title="Filter"
              variable="icon"
              onPress={handleChangeToggleFilter}
              className="pfizer__header-select-icon display-block-mobile ml10"
            />
          </div>

          <FieldSelect
            required
            customRef={ref}
            name="accessibility"
            value={accessibility}
            label="Accessibility"
            options={optionsAccessibility}
            onChange={handlerChangeAccessibility}
            styles={styleFieldSelectAccessibility}
            classNameLabel="libraries-compounds__prices-list-all"
            className="libraries-compounds__field-select-accessibility"
          />
          <FieldSelect
            required
            customRef={ref}
            options={options}
            name="pricesListAll"
            value={currentPrice}
            placeholder="Prepack"
            label="Default prepackage"
            styles={styleFieldSelectPrices}
            onChange={(value: TFuncArgs, opt: TFuncArgs) => {
              if (opt.action === "select-option") {
                handlerConfirmChangePrice(value);
              }
            }}
            title="Prepackage for seleted compounds"
            className="libraries-compounds__field-select-prices"
            classNameLabel="libraries-compounds__prices-list-all"
          />
          <Button
            isSvg
            color="error"
            variable="icon"
            icon="deleteSvg"
            title="Clear prepackage all"
            onPress={handlerConfirmClearPrice}
            disabled={!(!!Object.values(currentPrice)?.length)}
            className="ml10 align-self-end libraries-compounds__prepackage-clear"
          />
        </div>

        <div className="libraries-compounds__header-top-right flex flex-ai-center">
          <FieldSelect
            name="projectName"
            value={projectValue}
            options={optionsProjects}
            disabled={!user.authorized}
            placeholder="Last project name"
            onChange={handlerChangeProject}
            styles={styleFieldSelectProject}
            className="align-self-end pb5 libraries-compounds__field-select-project"
          />

          {accessibility?.value !== "ON_STOCK_POA" && <Button
            variable="info"
            label={labelAddSelected}
            onPress={handlerAddToProject}
            disabled={!disabledAddProject}
            className="ml10 align-self-end mb5 libraries-compounds__button-add-to-project"
          />}

          {accessibility?.value === "ON_STOCK_POA" && <Button
            variable="info"
            label="Download to XLS"
            onPress={handlerDownloadPOA}
            className="ml10 align-self-end mb5"
          />}
        </div>
      </div>

      <div className="relative flex flex-ai-center flex-jc-between libraries-compounds__border pb10">
        {isAvailabilityValid(accessibility?.value || "") && <FieldCheckbox
          className="ml10"
          label="Select all"
          value={checkboxAll}
          name="checkboxItemAll"
          onChange={handlerChangeCheckboxAll}
          classNameLabel="libraries-compounds__checkbox-all"
        />}

        <p className="projects__description projects__sub-header-text projects__sub-header-left">Description</p>
        <div className="projects__sub-header-right projects__sub-header-text flex flex-ai-center">
          <p className="projects__sub-header-text projects__text-accessibility">Accessibility</p>
          <p className="projects__sub-header-text projects__text-price">Price</p>
          <p className="projects__sub-header-text projects__text-quantity">Quantity</p>
        </div>
      </div>
    </div>
  );
};

export default HeaderList;
